import { Http } from 'src/shared/services/Http';

import { FetchedProgramProgress, UserProgramWeek } from '../models/programs';

export class ProgramsService {
    constructor(private http: Http) {}

    public async fetchProgramsProgress(): Promise<FetchedProgramProgress[]> {
        return this.http.GET<FetchedProgramProgress[]>(`programs/weeks-availability/`);
    }

    public updateProgramWeek(data: UserProgramWeek): Promise<UserProgramWeek> {
        return this.http.PATCH(`programs/${data.programId}/weeks/${data.weekNumber}/`, data);
    }
}
